export const buildOfficeSecurityPayload = (employeeId, values, dirtyFields) => {
  const payload = { employeeId };

  if (dirtyFields.officePinCode) payload.officePinCode = values.officePinCode;
  if (dirtyFields.facialRecognitionEnabled || values.faceImage) {
    payload.facialRecognitionEnabled = values.facialRecognitionEnabled;
  }
  if (values.faceImage) payload.faceImage = values.faceImage;
  if (dirtyFields.useAsProfilePicture || values.faceImage) {
    payload.useAsProfilePicture = values.useAsProfilePicture;
  }

  return Object.keys(payload).length > 1 ? payload : null;
};

export const buildAccessLevelPayload = (employeeId, values, dirtyFields) => {
  if (!dirtyFields.accessLevels) return null;

  return {
    employeeId,
    selectedAccessLevel: (values.accessLevels || []).map(({ value }) => value)
  };
};
